import { render, staticRenderFns } from "./AuthPasswordSimple.vue?vue&type=template&id=6e955ac4&scoped=true&"
import script from "./AuthPasswordSimple.vue?vue&type=script&lang=js&"
export * from "./AuthPasswordSimple.vue?vue&type=script&lang=js&"
import style0 from "./AuthPasswordSimple.vue?vue&type=style&index=0&id=6e955ac4&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e955ac4",
  null
  
)

export default component.exports